import React, { Component } from "react";

class Footer extends Component {
  render() {
    return (
      <div className="footerRoot">
        <div className="footerContainer">
          <div>
            <span className="footerText">© Molesey Photographic Club</span>
            <span className="spacer">|</span>
            <span className="footerText">
              <a href="http://www.facebook.com/group.php?gid=70536109109">
                <img
                  src="https://cdnjs.cloudflare.com/ajax/libs/webicons/2.0.0/webicons/webicon-facebook-s.png"
                  alt="facebook"
                />{" "}
                Find us on Facebook
              </a>
            </span>
          </div>
          <div>
            <span className="footerText">
              Member of the{" "}
              <a href="http://surreypa.org.uk/">
                Surrey Photographic Association
              </a>
            </span>
            <span className="spacer">|</span>
            <span className="footerText">
              Affiliated to the{" "}
              <a href="http://www.thepagb.org.uk/">
                Photographic Alliance of Great Britain
              </a>
            </span>
          </div>
        </div>
      </div>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/footer.jsx